import ApiURLs from "@/ApiURLs";
import { ChildcareProvider } from "@/models/childcare-provider/enrollment/getChildcareProviderModels";
import { UrlBuilder } from "@/builders/UrlBuilder";
import { EditChildcareProviderBaseModel } from "@/models/childcare-provider/enrollment/editChildcareProviderModels";
import HttpService from "@/services/HttpService";
import { MethodType } from "@/models/http/MethodType";

export class ChildcareProviderEnrollmentService {

    public static async getChildcareProviderInfoById(childcareProviderId: string): Promise<ChildcareProvider> {
        const url = UrlBuilder.build(ApiURLs.getChildcareProviderById, { childcareProviderId: childcareProviderId });

        const response = await HttpService.send<ChildcareProvider>(url, MethodType.GET);

        return response.data;
    }
    
    public static async editChildcareProvider(childcareProviderId: string, editChildcareProviderBaseModel: EditChildcareProviderBaseModel): Promise<ChildcareProvider> {
        const url = UrlBuilder.build(ApiURLs.editChildcareProvider, { childcareProviderId: childcareProviderId });

        const response = await HttpService.send<ChildcareProvider>(url, MethodType.PATCH, editChildcareProviderBaseModel);

        return response.data;
    }
}